<div class="margin-bottom"></div>
<h4 class="secondary-header">Equipamiento</h4>
<form [formGroup]="equipamientoFormGroup">
  <h5 class="third-header">Balanzas</h5>
  <div formArrayName="balanzas" *ngFor="let oc of balanzas().controls; let bzIndex=index">
    <div class="row" [formGroupName]="bzIndex">
      <div class="col">
        <mat-form-field class="margin-capacidad-input">
          <input matInput placeholder="Capacidad (g):" type="number" required formControlName="capacidad">
        </mat-form-field>
      </div>
      <!-- <mat-form-field class="col">
        <input matInput placeholder="Precision (n° decimales):" type="number" required formControlName="precision">
      </mat-form-field> -->
      <ng-select class="col" placeholder="Precisión (n° decimales): *" formControlName="precision" [required]="true">
        <ng-option *ngFor="let option of precisionOptions" [value]="option">
          {{ option }}
        </ng-option>
      </ng-select>
      <span class="validation-info"
        *ngIf="equipamientoFormGroup.get('balanzas').get(bzIndex.toString()).get('capacidad').invalid">Capacidad:
        (0-9999)</span>
      <span class="validation-info"
        *ngIf="equipamientoFormGroup.get('balanzas').get(bzIndex.toString()).get('precision').invalid">Seleccione
        precisión</span>
      <div class="col-2" *ngIf="balanzas().length > 1">
        <button type="button" class="float-right" mat-icon-button (click)="eliminarBalanza(bzIndex)" color="warn"
          matTooltip="Eliminar balanza">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <button type="button" (click)="agregarBalanza()" mat-icon-button color="primary" matTooltip="Agregar nueva balanza">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
    </button>
  </div>
  <div class="margin-bottom"></div>
  <h5 class="third-header">Germinadoras</h5>
  <div formArrayName="germinadores" *ngFor="let oc of germinadores().controls; let gerIndex=index">
    <div [formGroupName]="gerIndex">
      <div class="row">
        <mat-label class="col arial">Rango de temperaturas °C (*)</mat-label>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <input matInput placeholder="Mínima" required id="temperatura" type="number"
            formControlName="minima_temperatura">
        </mat-form-field>
        <mat-form-field class="col-6">
          <input matInput placeholder="Máxima" required id="temperatura" type="number"
            formControlName="maxima_temperatura">
        </mat-form-field>
      </div>
      <span class="validation-info"
        *ngIf="equipamientoFormGroup.get('germinadores').get(gerIndex.toString()).get('minima_temperatura').invalid || equipamientoFormGroup.get('germinadores').get(gerIndex.toString()).get('maxima_temperatura').invalid">Temperaturas:
        (0-999)
      </span>
      <div class="row">
        <mat-label class="col arial" >Alternancia de temperaturas *</mat-label>
      </div>
      <div class="row">
        <mat-radio-group class="col" aria-label="" required formControlName="tiene_alternancia_temperatura">
          <mat-radio-button [value]=true>Si</mat-radio-button>
          <mat-radio-button [value]=false>No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="row">
        <mat-label class="col arial">Alternancia de luz *</mat-label>
      </div>
      <div class="row">
        <mat-radio-group class="col-12" aria-label="" required formControlName="tiene_alternancia_luz">
          <mat-radio-button [value]=true>Si</mat-radio-button>
          <mat-radio-button [value]=false>No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-1">
        <button *ngIf="germinadores().length > 1" type="button" class="float-right" mat-icon-button
          (click)="eliminarGerminador(gerIndex)" color="warn" [disabled]="germinadores().length < 2"
          matTooltip="Eliminar germinador">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
        </button>
      </div>
      <ng-container *ngIf="(germinadores().controls.length > 1) && (gerIndex != germinadores().controls.length)">
        <hr>
      </ng-container>
    </div>
    <span *ngIf="oc.invalid" class="validation-info">Complete los campos requeridos</span>
  </div>
  <div class="row">
    <button type="button" (click)="agregarGerminador()" mat-icon-button color="primary"
      matTooltip="Agregar nueva germinador">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
    </button>
  </div>
  <div class="margin-bottom"></div>
  <h5 class="third-header">Divisores de muestra *</h5>
  <rpe-check-list-form [formInput]="formInputDivisorMuestra" (formValueChanges)="divisoresMuestraChange($event)"
    (formStatusChanges)="divisoresMuestraStatusChange($event)"></rpe-check-list-form>

  <div class="margin-bottom"></div>
  <h5 class="third-header">Otros equipos *</h5>
  <rpe-check-list-form [formInput]="formInputEquiposLaboratorio" (formValueChanges)="equiposChange($event)"
    (formStatusChanges)="equiposStatusChange($event)"></rpe-check-list-form>
  <button type="button" mat-raised-button (click)="addOther = true">Agregar otro equipo</button>
  <div class="row" *ngIf="addOther">
    <mat-form-field>
      <input matInput placeholder="Nombre del equipamiento" formControlName="otherEquipamiento">
    </mat-form-field>
  </div>
  <div class="row buttons d-flex justify-content-between pad" *ngIf="addOther">
    <button type="button" mat-raised-button color="basic" (click)="addOther = false">Cancelar</button>
    <button type="button" mat-raised-button color="primary" (click)="addOtherEquipamiento()">Agregar</button>
  </div>
  <div class="margin-bottom"></div>
  <h5 class="third-header">Especies y análisis *</h5>
  <div formArrayName="analisis_especie" *ngFor="let oc of analisisEspecie().controls; let eaIndex=index">
    <div [formGroupName]="eaIndex" class="row">
      <ng-select class="col" appendTo="body" placeholder="Especie" formControlName="especie" [multiple]="false"
        [required]="true">
        <ng-option *ngFor="let e of (this.especies$ | async)" [value]="e.id">
          {{ e.nombre_cientifico + ' | ' + e.nombre_comun }}
        </ng-option>
      </ng-select>
      <ng-select class="col" appendTo="body" placeholder="Análisis" formControlName="analisis" [multiple]="true"
        [required]="true">
        <ng-option *ngFor="let tAL of (this.tiposAnalisisLaboratorio$ | async)" [value]="tAL.id">
          {{ tAL.nombre}}
        </ng-option>
      </ng-select>
      <span class="validation-info" *ngIf="oc.invalid">Seleccione al menos una especie y un análisis</span>
      <div class="col-2" *ngIf="analisisEspecie().length > 1">
        <button type="button" mat-icon-button (click)="eliminarAnalisisEspecie(eaIndex)" color="warn"
          matTooltip="Eliminar especie y análisis">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <button type="button" (click)="agregarAnalisisEspecie()" mat-icon-button color="primary"
      matTooltip="Agregar nueva especie y análisis">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
    </button>
  </div>
</form>